import $axios from '../config.js'
import { url } from '../api_urls/ingredientClient.js'
// 获取顶部信息
export function getUpdateItem (params) {
  return $axios.post(url.getUpdateItem, params)
}
export function getReleaseCountry (params) {
  return $axios.post(url.getReleaseCountry, params)
}
export function getInciList (params) {
  return $axios.post(url.getInciList, params)
}
export function getInciDetail (params) {
  return $axios.post(url.getInciDetail, params)
}
export function getRelatedBasfProduct (params) {
  return $axios.post(url.getRelatedBasfProduct, params)
}
export function getGroupList (params) {
  return $axios.post(url.getGroupList, params)
}
export function getBrandList (params) {
  return $axios.post(url.getBrandList, params)
}
export function getInciAppAnalysis (params) {
  return $axios.post(url.getInciAppAnalysis, params)
}
export function getTop10ProductContainInci (params) {
  return $axios.post(url.getTop10ProductContainInci, params)
}
export function getConsumerProductChartData (params) {
  return $axios.post(url.getConsumerProductChartData, params)
}
export function getRelatedFormulation (params) {
  return $axios.post(url.getRelatedFormulation, params)
}
export function getMoreInfoData (params) {
  return $axios.post(url.getMoreInfoData, params)
}
export function getInciMoreFormulation (params) {
  return $axios.post(url.getInciMoreFormulation, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/ingredientClient.js